module.exports = __webpack_public_path__ + "static/media/sample_profile.64b9b92c.png";